import { OpenInNewTab } from 'seagull/icons';
import ExternalLinkButton from "../../ExternalLinkButton";
import { getAccountingDetails } from "../../../integrations/Accounting/accounting.utils";
import { Accounting } from "../../../types/api.model";
import { jsx as _jsx } from "react/jsx-runtime";
export const TimeActivityExternalLink = _ref => {
  let {
    timeActivity
  } = _ref;
  return /*#__PURE__*/_jsx(ExternalLinkButton, {
    href: timeActivity.url,
    testid: "time-activity-".concat(timeActivity.id, "-external-link"),
    tooltip: {
      title: "Open Time Activity in ".concat(getAccountingDetails(Accounting.QBO).fullName),
      placement: 'top'
    },
    openInNewTab: true,
    children: /*#__PURE__*/_jsx(OpenInNewTab, {})
  });
};